export function parseJSON(data) {
  try {
    return JSON.parse(data);
  } catch (e) {
    Bugsnag.notifyException(e);
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/utils/json.js